import router from '@/router/index';

const user = {
  state: {
    token: '',
    userInfo: '',
  },
  mutations: {
    SET_TOKEN: (state, result = '') => {
      state.token = result;
    },
    SET_INFO: (state, result = '') => {
      state.userInfo = result;
    },
  },
  actions: {
    Logout({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', null);
        commit('SET_INFO', {});
        sessionStorage.removeItem('token_portalUI');
        sessionStorage.removeItem('userInfo_portalUI');
        // sessionStorage.clear();
        resolve({ success: true });
      });
    },
  },

};

export default user;
